import "./image-map.scss";
import $ from "jquery";

$(function(){
    // Utility functions
    $.fn.mutation = function(cb, e) {
        e = e || { subtree:true, childList:true, characterData:true };
        $(this).each(function() {
            function callback(changes) { cb.call(node, changes, this); }
            var node = this;
            (new MutationObserver(callback)).observe(node, e);
        });
    };

    // Copy popover text to Bootstrap Accordions
    $('.vision-map').mutation(function(changes, observer) {
        if($('.vision-image').length > 0){
            $(".vision-popovers .vision-popover-wrap .vision-popover .vision-pp").each(function (index) {
                index += 1;
                if($(this).closest('.intro').length > 0) {
                    var cloneBody = $( this ).clone();
                    cloneBody.contents().appendTo( divCardBody );
                    cloneBody.appendTo( ".nav-contenu" );
                    return true;
                }
                //Accordion wrapper .card
                var divCard = jQuery("<div class='card' />");

                //Accordion header
                var divCardHeader = jQuery("<div class='card-header' id='heading"+ index + "' />");
                var h2CardH = jQuery("<h2 class='mb-0' />");
                var textHeader = $(".vision-tt-"+ index+ " p" ).clone().text();
                var accordeonHeader = jQuery('<button class="btn btn-image-interactive collapsed" type="button" data-toggle="collapse" data-id="'+index +'" data-target="#collapse'+index + '" aria-expanded="false" aria-controls="collapse'+index +'">').text(textHeader);
                accordeonHeader.appendTo( h2CardH );
                h2CardH.appendTo( divCardHeader );

                //Accordion body
                var divCardCollapse = jQuery("<div class='collapse' id='collapse"+ index + "' data-id='"+ index + "' aria-labelledby='heading"+ index + "' data-parent='#accordionMenu' />");
                var divCardBody = jQuery("<div class='card-body' />");
                var cloneBody = $( this ).clone();
                cloneBody.contents().appendTo( divCardBody );
                divCardBody.appendTo( divCardCollapse );

                // Assemble bs.collapse
                divCardHeader.appendTo( divCard );
                divCardCollapse.appendTo( divCard );
                divCard.appendTo( ".nav-contenu" );
            });
            observer.disconnect();
        }
    });

    // Vision interactive & Accordion Interaction
    $('.nav-contenu').mutation(function(changes, observer) {
        if($('.nav-contenu .card').length > 0){
            $('.nav-contenu .card a').filter(function(){
                return $(this).attr("href").match(/\.(pdf|doc|docx|ppt|pptx|xls|slxs|epub|odp|ods|txt|rtf)$/i);
            }).attr("download", "");
            var target, tooltip, tooltips;
            $('.btn-image-interactive').click(function(){
                var trigger = true;
                tooltips = $('.vision-tooltips > div');
                $(".collapse").on('show.bs.collapse', function(e) {
                    if(trigger === true){
                        target = $(this).attr('data-id');
                        tooltips.removeClass('vision-show');
                        tooltip = $('.vision-tooltips > div:nth-child('+ target +')');
                        tooltip.addClass('vision-show vision-tooltip-top');
                        var layerHeight = $('.vision-lr-'+ target ).parent().height();
                        var layerScale = $('.vision-lr-'+ target ).closest('.vision-layer-zoom').css('transform').split(',')[3];
                        var tooltipOffset = (layerHeight*-1*layerScale/2);
                        tooltip.find('.vision-tooltip-offset').css('margin-top', tooltipOffset);
                        tooltip.removeClass('vision-hide');
                    }
                });
                $(".collapse").on('hide.bs.collapse', function(e) {
                    if(trigger === true){
                        target = $(this).attr('data-id');
                        tooltips.removeClass('vision-show');
                        tooltip = $('.vision-tooltips > div:nth-child('+ target +')');
                        tooltip.addClass('vision-hide');
                        tooltip.removeClass('vision-show');
                    }
                });
            });

            //toggle accordions from map points
            $('.vision-lr').on('click touchstart', function(){
                target = $(this).attr('data-id');
                $("#collapse"+target).collapse('toggle');
                if ($(window).width() < 992){
                    $('html, body').animate({
                        scrollTop: $("#collapse"+target).offset().top
                    }, 600);
                }
            });

            observer.disconnect();
        }
    });
});